var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBikeCartoonImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "17.43 87.96 702.54 321.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.099 401.15c-13.663 0.495-45.768 2.669-20.88-6.259 10.021 0.198 45.881-1.61 14.718-0.81702 66.501 1.98 133.46-3.16 199.59 5.9-10.705 7.147-46.766 3.786-67.761 4.519-41.902-0.487-83.79-1.792-125.66-3.343z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m189.23 220.48c11.873 2.372 18.408-1.101 16.401-13.929 8.413-16.852-11.081-25.868-28.395-25.267-30.017-0.097992-62.005 5.774-83.38 28.723-9.2687 3.254-6.0406 28.491 5.785 22.419 29.863-3.982 59.726-7.964 89.589-11.946z",
    fill: "#2a2c2f",
    stroke: "#000",
    strokeWidth: 3.026,
    "data-darkreader-inline-fill": "",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineFill: "#222426",
      darkreaderInlineStroke: "#e8e6e3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m231.08 316.45c1.667 53.174-53.682 96.578-105 84.294-50.206-8.369-83.846-66.399-64.472-113.88 17.014-50.065 83.085-72.411 127.4-44.001 25.605 15.046 42.364 43.789 42.073 73.585z",
    stroke: "#1a1b1b",
    strokeWidth: 3.328,
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#d7d4cf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#e8e6e3"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m497 182.36c2 32-32 170-38 180s-224 6-232 2-28-24-28-24 26 14 40 16 200 8 204 0 10-2 16-20 38-154 38-154z",
    fillRule: "evenodd",
    strokeWidth: 2.875
  })), /*#__PURE__*/React.createElement("path", {
    d: "m193.5 314.93c1.255 38.473-48.145 62.07-78.628 40.146-31.083-17.727-28.384-68.098 4.158-82.716 31.386-17.5 75.11 5.554 74.47 42.57z",
    fill: "#f0f0f2",
    strokeWidth: 2.648,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#dfdcd8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#dad7d2"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m156.85 380.72c12.41 3.626 44.057-29.469 16.818-11.742-13.504 16.441-57.221-0.33905-55.997 7.748 11.992 6.221 26.164 6.231 39.179 3.994z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m154.58 368.45c16.364 2.998 34.353-27.857 7.858-11.236-12.619 12.3-47.315-7.399-45.781 3.047 10.329 8.613 25.008 10.884 37.923 8.189z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#e8e6e3"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.9 333.93c-3.909-16.585-10.646-33.359-12.832-49.827 6.342-11.375 7.268-27.21 20.479-32.929 27.924-19.02 55.848-38.041 83.772-57.062 38.539-1.793 77.079-3.585 115.62-5.378 8.993 7.033 19.838 12.442 27.729 20.439 11.739 25.917-4.305 54.25-14.567 77.937-9.011 26.583-25.556 47.124-52.884 55.894-23.662 6.381-48.78 0.91998-73.043 3.295-24.269 1.344-48.458 0.14099-71.621-7.664-7.529-1.67-15.082-3.23-22.651-4.705z",
    fill: "#808282",
    strokeWidth: 1.009,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#5f676b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.94 185.99c31.807-25.781 67.769-53.221 110.18-51.272 27.715 14.302 31.942 52.866-0.47202 65.082-27.025 26.801-68.664-2.168-101.07 9.589-17.304 5.203-36.426-20.921-8.64-23.399z",
    fill: "#ff7f00",
    strokeWidth: 3.734,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#cc6600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m319.25 322.82c6.432 16.608 38.432-11.309 53.324-14.698 34.12-17.269 72.022-30.712 99.26-58.549 20.878-21.027-20.726-45.068-20.7-11.072-1.727 31.031-37.499 37.799-60.141 49.797-24.154 11-48.013 22.639-71.743 34.522z",
    fill: "#fff",
    fillOpacity: 0.724,
    stroke: "#d9dcda",
    strokeWidth: 1.009,
    "data-darkreader-inline-fill": "",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineFill: "#181a1b",
      darkreaderInlineStroke: "#d1cdc7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.74 327.7c-9.913 10.896-45.24 8.643-29.559-7.883 16.725-2.132 32.988-10.666 41.106-16.314-3.533 8.213-8.076 15.949-11.547 24.197z",
    fill: "#f4f6f7",
    fillOpacity: 0.535,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#e2dfdc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m695.8 318.97c1.413 45.576-49.213 80.175-91.599 65.503-40.599-10.505-63.075-61.892-41.087-98.196 21.368-41.112 83.94-48.154 114.34-13.423 11.649 12.341 18.43 29.119 18.342 46.116z",
    fill: "#f0f0f2",
    strokeWidth: 4.875,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#202324"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#e8e6e3"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m541.64 321.16c-4.297 23.476-33.473 21.997-19.907-3.977 2.4351-30.544 13.337-59.415 34.747-81.584 25.249-29.513 68.894-30.459 104.64-26.193 21.842-3.076 69.932 25.127 24.62 31.005-26.001 1.115-57.899-10.234-77.683 12.808-12.999 22.082-48.494 10.749-55.38 37.281-4.11 10.058-7.655 20.338-11.04 30.66z",
    fill: "#ff7f00",
    strokeWidth: 3.908,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#cc6600"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m464.67 109.24c-10.839-5.861-79.399 12.692-47.456-4.734 17.617-4.532 38.611-0.17798 49.883-14.022 17.54 13.785 42.933 35.624 35.649 59.544-16.84 18.82-28.275-44.821-62.145-4.547-30.315-9.472 18.303-28.847 24.069-36.241z",
    strokeWidth: 5.043
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m608.86 317.8c-34.824-47.259-86.92-107.68-119.52-156.51-8.862-35.637 20.428-7.708 27.471 4.692 28.258 36.85 85.156 103.9 106.57 145.22 1.911 7.112-10.385 7.926-14.526 6.595z",
    strokeWidth: 3.934
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m649.28 405.98c-39.709-3.268-79.845 5.272-119.29-2.332-10.883 1.457-44.25 3.067-41.9 1.9 25.945-6.221 52.898-6.551 79.291-8.767-3.495-20.059-44.367-42.049-30.155-70.379 12.54-12.592 17.704-63.458 34.584-50.825-16.367 30.495-15.251 74.363 16.454 94.574 36.392 25.749 96.442 4.026 101.88-42.101 8.447-40.989-31.423-84.34-73.255-76.313-24.144-3.434 22.397-19.228 31.314-11.88 32.317-10.069 61.733 16.998 65.714 48.235 11.295 39.836-4.424 87.113-41.356 107.79 8.394 9.684 67.951 5.448 32.396 9.113-18.538 0.857-37.12 1.463-55.676 0.982z",
    strokeWidth: 4.917
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m670.58 399.37c-3.648-4.252-3.647 4.251 0 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m518.3 392.79l1.604-0.376-1.604 0.376z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m449.04 334.64c-3.519-12.622 32.183-55.084 15.968-23.142-4.025 8.509-9.557 16.27-15.968 23.142z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m427.36 341.42c18.803-4.925-9.508 5.136 0 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m388.16 337.9c1.628-5.835 2.04 3.303 0 0z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m402.03 336.2c-16.196-3.905 0.31702-15.468 6.684-1.719 14.207 4.338 19.537-35.45 22.083-7.971-5.476 9.586-18.621 13.782-28.767 9.69z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m355.64 332.15c-21.208-24.684 50.096-15.215 8.321-13.14-15.575-2.917 4.47 27.827-8.321 13.14z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m364.12 334.69c-7.82-11.399 35.795 1.312 7.474 0.022003l-3.442 0.022-4.032-0.044z",
    fill: "#f4f6f7",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#e2dfdc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m385.64 330.78c-0.40399-10.731 6.218 5.248 0 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m138.3 320.08c3.332-1.614 1.821 2.04 0 0z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m613.12 312.22c-6.139-19.181-29.62-36.027-29.626-54.284 5.773 16.959 38.861 43.914 29.626 54.284z",
    fill: "#fff",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#e8e6e3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m374.55 312.63c2.8-9.459 11.099 5.317 0 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m436.58 308.32c9.525-16.426-0.26901 10.623 0 0z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m323.18 307.25c16.237-7.584 29.331-44.273 2.291-39.449-6.927-28.92 17.247 37.4-14.466 25.629 8.662-1.201 22.112-30.889 4.335-17.483-14.706-12.902 1.942-32.703-5.157-44.722 10.221-12.787 30.386-13.613 33.777-28.21 12.469 4.198 29.029 7.805 7.965 13.411-33.785 6.968-14.168 44.013 13.469 36.976 25.423-2.232 49.379 29.817 66.654 0.353-6.112-17.646 17.489-30.609 16.668-8.415-3.066 12.952-13.359 27.794-18.716 25.947-14.619 16.675-41.708 7.878-45.822-4.489 6.428 14.872-14.747-14.656-2.752 8.618 8.015 23.698-20.428 21.443-18.656 1.228-19.787-23.888-13.256 15.27-18.867 23.689 6.168 13.901-3.765-5.663-6.457 9.313-5.037 1.796-9.415-1.819-14.266-2.396z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#181a1b"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m334.64 253.56c-2.952-13.18-15.472-32.497-13.533-11.389 1.615 4.084 20.463 35.458 13.533 11.389z",
    fillOpacity: 0.935
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m443.05 244.02c1.996-15.663-5.773 18.906 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m346.31 209.75c-1.552-4.165-3.184 4.394 0 0z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m405.51 305.94c13.794-7.699 8.566 6.867 0 0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m447.68 296.98c9.999-11.743 3.06-21.178-4.04-4.862-12.654 13.271-4.311-30.194 3.925-37.769 5.78-26.796 40.917-3.621 20.267 13.236-1.966 3.578-25.881 39.669-20.152 29.395z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m400.8 298.54c15.929-11.389 20.125 5.151 0.888 0.28101l-0.888-0.281z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m90.16 291.75c2.4769-13.286 33.802-29.657 12.571-6.874 1.826 6.991-23.18 23.912-12.571 6.874z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m192.1 206.21c4.373-30.507 36.573-23.337 50.702-4.273 27.854 21.313 60.458 0.659 86.595-12.532 17.247-12.356 28.182 4.929 8.637 13.194-19.349 20.958-41.586 36.997-67.958 47.976-19.761 2.152-10.324 38.174-31.518 26.221-9.148-26.351-30.553-47.973-46.458-70.586z",
    fill: "#c05c22",
    fillRule: "evenodd",
    stroke: "#1a1b1b",
    strokeWidth: 3.429,
    "data-darkreader-inline-fill": "",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineFill: "#9a4a1b",
      darkreaderInlineStroke: "#d7d4cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.72 295.35c-13.189-1.602-36.714-1.932-10.442-9.845 12.452-19.917 57.11-1.912 29.523 11.878-6.415 0.20401-12.843-0.54898-19.081-2.033z",
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#dad7d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.54 294.83c-25.325-26.615 7.975-47.815 32.179-54.373-4.075 5.308-50.348 22.748-26.89 47.731 6.946 3.62-1.545 11.427-5.289 6.642z",
    fill: "#eceeee",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#dddad5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m471.27 292.07c3.709-9.793 16.326-40.9 7.868-14.296-3.096 2.571-2.413 17.038-7.868 14.296z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m186.5 282.74c-4.624-12.893 10.247 11.491 0 0z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m483.44 254.13c4.396-17.596 14.204-53.042-16.064-42.035-19.832-6.243-42.676 2.943-38.504 13.343-9.173-11.323-40.244-7.082-37.277-15.516 26.164-7.32 55.959 4.672 77.308-16.968 24.929-9.728-7.168-46.675 0.032013-48.512-21.376-9.29-58.641 10.38-67.433 11.532 13.172-6.784 32.547-29.742 40.719-13.791 22.397-15.92 34.864-0.44498 49.854 13.922 3.824-8.974-9.214-32.401 9.627-19.303 12.509 20.145 24.81 40.913 34.567 62.509-11.148-1.926-32.372-35.204-28.234-6.074-10.521-1.305-0.48001-35.64-10.066-10.058 1.129 15.213-12.769 26.49-8.144 4.678-7.333 22.437 9.052 47.089-5.939 69.705l-0.453-0.337 7e-3 -3.095z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m526.85 187.56c-2.264-3.906-1.328 3.825 0 0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m494.52 173.2c3.933-17.943-13.235 13.297 0 0z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m514.85 174.72c-5.231 0.095001 3.421 5.027 0 0z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m513.23 166.38c-4.555-10.478-1.361 9.668 0 0z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m504.82 158.56c-5.533-17.521-16.836 8.248-0.146 5.496 2.394-1.106 2.025-4.309 0.146-5.496z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m570.9 243.98c-12.281-4.985-32.349-46.629-11.97-18.034 0.19299 1.356 24.436 26.472 11.97 18.034z",
    fill: "#fff",
    strokeOpacity: 0.524,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#e8e6e3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12151b",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#0e1116"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m268.02 243.71c0.026001-30.983-50.435-24.811-51.664-56.222 19.495 32.351 66.046 38.647 95.606 16.663 20.745-18.099 39.72-11.329 57.066-31.627 29.327-16.612-13.431 14.579-21.468 21.494-25.089 18.36-49.107 40.779-79.54 49.692z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m369.4 209.24c16.084-6.298 15.859 5.168 0 0z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m439.6 134.18c3.162-12.157 32.753-21.934 13.067-4.191 0.883 6.763-9.258 5.146-13.067 4.191z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m491.14 125.15c-3.558-12.166-27.139-31.288-2.849-14.491 3.003 2.213 14.689 16.556 2.849 14.491z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m443.64 117.58c3.741-11.754 5.926 6.812 0 0z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m410.41 116.51c-4.161-24.534 52.014-5.222 13.204-0.80402-4.067 1.077-9.294 3.874-13.204 0.80402z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m449.44 114.25c-3.629-7.938 12.42 1.833 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#e8e6e3"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.248 313.76c-32.023 6.031 9.3491-39.172 13.231-53.776 18.626-32.746 49.57-65.782 91.295-65.982 25.919-5.031 53.557 0.052002 71.322 20.254 15.288 14.56 64.065 43.373 39.564 65.462-12.98 29.504-53.659-42.875-85.107-39.291-33.817-2.819-73.718 6.549-88.249 39.586-9.3679 15.536-19.109 37.904-42.056 33.747z",
    fill: "#ff7f00",
    strokeWidth: 3.49,
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#cc6600"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m76.133 299.32c41.897-2.05 83.821-5.011 125.7-6.491 37.081 6.455 74.813-1.384 112.07 1.68 17.361-0.54602 29.381-42.57 25.161-8.032-11.329 32.351-53.952 17.006-80.029 21.828-20.335-4.567-36.114 10.931-55.499 10.504-37.538 2.018-75.076 4.036-112.61 6.054-6.494-7.278-38.379-15.135-14.788-25.543z",
    strokeWidth: 3.732
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m84.543 333.93c55.121-1.345 110.24-2.689 165.36-4.034 6.182-11.724 21.511-28.58 12.099-5.377 24.924 11.34 55.846 22.98 84.361 16.133 27.191-8.879 66.169 6.622 86.378-14.789 15.386-21.435 23.645-56.738 44.975-69.144-0.36099 26.581-17.021 51.053-32.312 72.21-14.586 29.683-49.171 18.384-75.319 21.827-26.601 3.144-56.024 11.95-80.354-3.718-23.635-10.627-50.307-2.263-75.324-3.193-37.845 0.93701-75.764 5.072-113.54 4.306-7.4199-1.284-15.829-5.666-16.322-14.221z",
    strokeWidth: 3.228
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#181a1b"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m84.543 305.7c39.524-1.091 79.01-5.921 118.44-6.525 27.229 14.766-19.784-2.915-30.045 4.31-29.42 1.889-58.929 2.043-88.399 2.215z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m97.643 337.96c54.672-1.345 109.34-2.689 164.02-4.033-50.169 2.934-100.32 7.192-150.57 8.066-4.61-0.73602-9.333-1.702-13.444-4.033h-9.9e-5z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m536.09 105.29c-42.94-4.258-39.943 68.069 2.705 59.984 8.704-12.631-3.34-41.33-2.705-59.984z",
    fill: "#c5e1e5",
    stroke: "#000",
    strokeWidth: 5.043,
    "data-darkreader-inline-fill": "",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineFill: "#b3d8dd",
      darkreaderInlineStroke: "#e8e6e3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m512.22 139.43c-16.443-16.178 28.088-36.513 10.664-19.243-8.959 2.226-7.27 12.343-10.664 19.243z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m345.19 232.02c17.472-18.973 50.209-8.799 71.347-6.486 16.833 15.928 0.901 31.812-15.953 17.08-16.472-8.236-36.946-19.497-51.61-7.351l-2.703-2.026-1.081-1.217z",
    fill: "#fff",
    fillOpacity: 0.724,
    stroke: "#000",
    strokeOpacity: 0.524,
    strokeWidth: 2.522,
    "data-darkreader-inline-fill": "",
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineFill: "#e8e6e3",
      darkreaderInlineStroke: "#e8e6e3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-darkreader-inline-fill": "",
    style: {
      darkreaderInlineFill: "#181a1b"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.747 212.9c-6.1421 0.55698-12.23 22.328-7.0937 25.956 20.092 6.187 27.63-20.945 7.0937-25.956z",
    stroke: "#000",
    strokeWidth: 1.818,
    "data-darkreader-inline-stroke": "",
    style: {
      darkreaderInlineStroke: "#e8e6e3"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.849,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73 232.36c16.686-18.194 37.806-34.481 64.123-32.622 31.332-0.40698-22.442 3.475-29.846 14.824-11.135 6.468-22.564 12.443-34.277 17.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403 166.36c16.819-8.933 50.242-24.096 61.906-5.219-20.74-10.353-41.545-0.63-61.906 5.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m583 224.36c11.234-7.903 39.829-12.166 45.695-8.945-16.87-1.771-30.736 18.905-45.695 8.945z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeCartoonImg2);
export default __webpack_public_path__ + "static/media/bike_cartoon_img2.90db063ff7c26fe7f057dca1869eedd2.svg";
export { ForwardRef as ReactComponent };